import { useTranslation } from 'react-i18next';
import FactContainer from './FactContainer';

const FactTwo = ({ history }) => {
  const { t } = useTranslation();
  return (
    <FactContainer
      history={history}
      bigText
      factTitle={t('fact_2')}
      factDescription={{
        __html: t('fact_2_disclaimer'),
      }}
      nextUrl="q15"
      screenName="f2"
    />
  );
};

export default FactTwo;
